const HOSTS = {
  API: process.env.VUE_APP_URL,
  HOST: process.env.VUE_APP_HOST,
  FRANCHISING: process.env.FRANCHISING,
  FRANCHISING_SIGLA: process.env.FRANCHISING_SIGLA
}

module.exports = HOSTS;
